import { ROUTES } from '@/env/routes'
import { setUIState } from '@/ui/useUIStore'
import clsx from 'clsx'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import styles from './index.module.scss'
import SideIcon from './assets/side.svg'
import { useCommon } from '@/core/useCommon'
import UserData from '@/views/User/UserData'
import { Button } from '@/components/ui/button'
import { isDev } from '@/env'

const Header = () => {
  const { push } = useCommon()
  const { pathname } = useLocation()
  // 登入頁
  const loginRoute = ROUTES.LOGIN()

  // 特定 router 隱藏 Header
  const hidden = useMemo(() => {
    // 登入頁不顯示 Header
    return pathname === loginRoute
  }, [pathname])

  return (
    <div
      className={clsx('fixed top-0 right-0 left-0 z-10 flex h-48 w-full items-center justify-between border-b border-[#EBEBEB] bg-white px-12 sm:hidden', {
        hidden,
      })}>
      {/* 左邊 */}
      <div className="flex items-end gap-4">
        <div onClick={() => setUIState({ sidebar: true })}>
          <SideIcon className="size-24" />
        </div>
        <div className={clsx('bg-full h-28 w-68', styles.logo)} onClick={() => push(ROUTES.HOME())} />
      </div>

      {isDev && (
        <div>
          <Button className="text-16 h-34" onClick={() => push(ROUTES.DEMO())}>
            去 Demo 頁
          </Button>
        </div>
      )}

      {/* 右邊 */}
      <div>
        <UserData />
      </div>
    </div>
  )
}

export default Header
